import { Router, RouterProps } from '@gatsbyjs/reach-router';
import React from 'react';
import styled, { css } from 'styled-components';

type Props = {
  children: React.ReactNode;
  height?: '100%' | 'auto';
  width?: '100%' | 'auto';
} & RouterProps;

const DHRouter: React.FCC<Props> = ({
  children,
  height = '100%',
  primary = false,
  width = 'auto',
  ...rest
}) => (
  <StyledRouter $height={height} primary={primary} $width={width} {...rest}>
    {children}
  </StyledRouter>
);

const StyledRouter = styled(Router)<{
  $height: '100%' | 'auto';
  $width: '100%' | 'auto';
}>(
  ({ $height = '100%', $width = 'auto' }) => css`
    height: ${$height};
    width: ${$width};
  `,
);

export default DHRouter;
